import React from 'react';
import { Col, Row } from 'components';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';
import { DeliveryInformation } from './DeliveryInformation';
import { PaymentTerms } from './PaymentTerms';
import { ItemsTable } from './ItemsTable';
import { useGeneral } from './useGeneral';
import { General } from './General';

export const OrderGeneral = React.memo(() => {
  const { data } = useGeneral();
  return (
    <HasAccess role={PERMISSIONS.orders.order.read}>
      <Row>
        <Col span={24}>
          <Row wrap={false} justify={'space-between'}>
            <Col flex={'480px'}>
              <Row gutter={[32, 32]}>
                <Col span={24}>
                  <PaymentTerms data={data.paymentTerms || {}} />
                </Col>
                <Col span={24}>
                  <DeliveryInformation data={data.delivery || {}} />
                </Col>
              </Row>
            </Col>
            <Col flex={'385px'}>
              <General
                data={{
                  notes: data.additionalNotes,
                  margin: data.margin,
                  discount: data.discount,
                }}
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <ItemsTable />
        </Col>
      </Row>
    </HasAccess>
  );
});
